import React from "react";
import FormRow from "../../components/formrow";
import { type GetSetValueProp, type TimeOption, timeOptions } from "../models";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";

export default (props: GetSetValueProp<number>) => {
  const options: TimeOption[] = [
    { text: RESX.Advancing.NoValue, value: 0 },
    ...timeOptions
  ];
  return <FormRow label={RESX.EmbedWizard.PastShows}>
    <BaseReactSelectDropdown
      options={options}
      value={options.find(o => o.value === props.value)}
      onChange={v => { props.setValue(v.value); }}
      config={{}}
      getLabel={o => o.text}
      getValue={o => o.value}
      excludeKeys={[]}
    />
  </FormRow>;
};
